import React from 'react';
import { withDevTools, createDebugger } from '../utils/debugConfig';

// Create debugger for AttorneyDossier component
const debug = createDebugger('AttorneyDossier');

const AttorneyDossier = ({ attorney }) => {
  if (!attorney) {
    return (
      <div className="attorney-dossier empty-dossier">
        <h2>No Attorney Selected</h2>
        <p>Please select an attorney from the map or list.</p>
      </div>
    );
  }

  return (
    <div className="attorney-dossier">
      <h2>Attorney Information</h2>
      
      <div className="dossier-section">
        <h3>{attorney.name || 'Attorney'}</h3>
        <p className="practice-area">{attorney.practiceArea || attorney.specialty || 'General Practice'}</p>
        
        {attorney.distance && (
          <p className="distance">
            <strong>Distance:</strong> {attorney.distance} miles
          </p>
        )}
      </div>
      
      <div className="dossier-section">
        <h4>Contact Information</h4>
        <ul className="contact-list">
          {attorney.phone && (
            <li>
              <strong>Phone:</strong> <a href={`tel:${attorney.phone}`}>{attorney.phone}</a>
            </li>
          )}
          
          {attorney.email && (
            <li>
              <strong>Email:</strong> <a href={`mailto:${attorney.email}`}>{attorney.email}</a>
            </li>
          )}
          
          {attorney.website && (
            <li>
              <strong>Website:</strong> <a href={attorney.website} target="_blank" rel="noopener noreferrer">Visit Website</a>
            </li>
          )}
        </ul>
      </div>
      
      {attorney.address && (
        <div className="dossier-section">
          <h4>Office Address</h4>
          <address>{attorney.address}</address>
        </div>
      )}
      
      {attorney.bio && (
        <div className="dossier-section">
          <h4>About</h4>
          <p>{attorney.bio}</p>
        </div>
      )}
      
      {attorney.expertise && attorney.expertise.length > 0 && (
        <div className="dossier-section">
          <h4>Areas of Expertise</h4>
          <ul className="expertise-list">
            {attorney.expertise.map((item, index) => (
              <li key={index}>{item}</li>
            ))}
          </ul>
        </div>
      )}
      
      <div className="dossier-actions">
        <button className="contact-button">Contact This Attorney</button>
      </div>
    </div>
  );
};

// Export the component with enhanced DevTools support
export default withDevTools(AttorneyDossier, {
  displayName: 'AttorneyDossier',
  type: 'display',
  description: 'Displays detailed information about a selected attorney',
  responsibleFor: ['attorney profile display', 'contact information', 'expertise listing']
}); 